import React, { useEffect, useState } from "react";

// Hooks
import usePlacesAutocomplete, { getGeocode } from "use-places-autocomplete";
import { FieldIcons } from "@magento/venia-ui/lib/components/Field";
import loadGmaps from "@Src_main/utils/GMapsJSImport";

// Styles
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./addressAutocomplete.module.scss";
export var AddressAutocompleteNoForm = _ref => {
  var {
    classes: propClasses,
    onSelectedAddress,
    getSelectedAddressDetails,
    fullAddress,
    id,
    after,
    before,
    label,
    errorPass,
    getValueSetter,
    onChange
  } = _ref;
  var classes = mergeClasses(defaultClasses, propClasses);

  // Autocomplete
  var {
    value,
    suggestions: {
      data
    },
    setValue,
    init,
    ready
  } = usePlacesAutocomplete({
    debounce: 300,
    initOnMount: false
  });
  useEffect(() => {
    loadGmaps(() => init());
  }, [init]);
  if (getValueSetter)
    // External setter for set value function
    getValueSetter(value => {
      setValue(value);
    });
  var [suggestionsVisible, toggleSuggestions] = useState(false);
  var [isFocused, setIsFocused] = useState(false);
  var [inputValue, setInputValue] = useState("");
  var handleChange = event => {
    setInputValue(event.target.value);
    if (onChange) onChange(event);
  };

  // On field value change
  useEffect(() => {
    // Field value has changed, update the hook value and show the suggestions
    if (inputValue && inputValue !== value) {
      setValue(inputValue);
      toggleSuggestions(true);
    }
    // Same values or no value at all, hide the suggestions
    else toggleSuggestions(false);
  }, [inputValue]);
  var handleSelect = _ref2 => {
    var {
      description,
      structured_formatting
    } = _ref2;
    return () => {
      var value = fullAddress ? description : structured_formatting.main_text;

      // Set both too same value
      setValue(value);
      setInputValue(value);

      // Pass address info to other components
      if (getSelectedAddressDetails) getGeocode({
        address: description
      }).then(_ref3 => {
        var [result] = _ref3;
        return getSelectedAddressDetails(result);
      }).catch(() => console.error);
      if (onSelectedAddress) onSelectedAddress(value);

      // Hide suggestions
      toggleSuggestions(false);
    };
  };
  var inputError = errorPass ? classes.error : "";
  var labelError = errorPass ? classes.error_label : "";
  var className = "uk-input uk-form-large address-autocomplete uk-background-creamer uk-box-shadow-medium ".concat(inputError, " ").concat(classes.root);
  useEffect(() => {
    if (data.length && !inputValue) handleSelect(data[0])();
  }, [data]);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    onBlur: () => {
      // Wait for click on suggestion
      setTimeout(() => {
        toggleSuggestions(false);
        setIsFocused(false);
      }, 500);
    },
    onFocus: () => {
      if (data && data.length > 0) toggleSuggestions(true);
      setIsFocused(true);
    }
  }, /*#__PURE__*/React.createElement(FieldIcons, {
    after: after,
    before: before,
    classes: {
      root: classes.fieldIcons
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "float-labels ".concat(classes.inputContainer)
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: id || "inputField",
    value: inputValue,
    onChange: handleChange,
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "none",
    spellCheck: false,
    disabled: !ready
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: id || "inputField",
    className: "floating-label ".concat(labelError)
  }, label))), isFocused && suggestionsVisible && data && data.length > 0 ? /*#__PURE__*/React.createElement("ul", {
    className: classes.suggestions
  }, data.map(suggestion => {
    var {
      place_id,
      structured_formatting: {
        main_text,
        secondary_text
      }
    } = suggestion;
    return /*#__PURE__*/React.createElement("li", {
      key: place_id,
      onClick: handleSelect(suggestion)
    }, /*#__PURE__*/React.createElement("strong", null, main_text), " ", /*#__PURE__*/React.createElement("small", null, secondary_text));
  })) : null);
};
export default AddressAutocompleteNoForm;